import React from 'react';
import { dispatch } from '@rematch/core';
import { connect } from 'react-redux';
import { Route } from "react-router-dom";
import AccountUserList from './Designer/UserList';
import './styles.css'

class AccountUsers extends React.Component {

	componentWillMount() {
		dispatch.platform.setAcceptServerEvents(true);
		dispatch.platform.getStats();
		dispatch.app.setCurrentContext("platform-account");
	}

	render() {
		return (
			<div>
				<Route exact path="/app/platform/accountusers" render={() => (<AccountUserList {...this.props} />)} />
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		allUsers: state.platform.allUsers,
		forgotSuccess: state.forgot.forgotPwdSuccess,
		resetPasswordLoading: state.loading.effects.forgot.forgotAsync,
		forgotError: state.forgot.forgotPwdError,
		totalCount: state.platform.totalCount
	};
}

const connectedAccountUsers = connect(mapStateToProps)(AccountUsers);
export { connectedAccountUsers as AccountUsers }; 